import { render } from "./imprint.vue?vue&type=template&id=a0d42d26"
import script from "./imprint.vue?vue&type=script&lang=js"
export * from "./imprint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__